/**
 * btk-fly-to-cart.js - the "added to basket" swoosh (Arden, 2026-10-11)
 * ----------------------------------------------------------------
 * When something is added to the basket, a copy of its picture flies from
 * where it was added - the listing card, the product page - shrinking into the
 * header basket icon, which then gives a little bounce. The theme (Enterprise)
 * has no animation of its own for this: only open the drawer, go to the cart,
 * or nothing.
 *
 * Every add on the site announces itself with one of these events:
 *   btk:item-added       - our listings, the door front matrix
 *   on:cart:add          - the theme's product form (a new line)
 *   on:line-item:change  - the theme's product form (more of a line already in)
 * The picture is the one nearest the button pressed just before (pointerdown);
 * with no picture to hand the basket just bounces. Reduced motion: bounce only.
 *
 * Round two (Arden, 2026-10-11): it starts FROM THE CLICK and AT THE CLICK -
 * pressing any add-to-basket button (kitchen units' Add to Basket, the card
 * and matrix "Add" buttons, the theme's) flies straight away, rather than
 * waiting for the add to finish (the delay), and from the pointer rather than
 * the picture. Unit pages save before they announce anything, so the click is
 * what catches them. The events above remain for adds with no button press.
 */
(function () {
  'use strict';

  var lastImg = null, lastAt = 0, lastFly = 0, lastX = null, lastY = null;

  // Remember the picture beside whatever is pressed: its card, its form, or on
  // a product page the main product image.
  document.addEventListener('pointerdown', function (e) {
    var b = e.target && e.target.closest && e.target.closest('button, a, [role="button"], input[type="submit"]');
    if (!b) return;
    var scope = b.closest('form[action*="/cart/add"], product-form, [data-product-card], .product-card, .card, [class*="card"], [class*="product"]');
    var img = scope && scope.querySelector('img');
    if (!img) img = document.querySelector('.product-media img, .media-gallery img, [class*="gallery"] img, main img');
    lastImg = img || null;
    lastAt = Date.now();
    lastX = e.clientX; lastY = e.clientY;
  }, true);

  // An add-to-basket button: by its markers, else by its words.
  function isAddButton(b) {
    if (!b || b.disabled || b.getAttribute('aria-disabled') === 'true') return false;
    if (b.name === 'add' || b.hasAttribute('data-add-to-cart-text')) return true;
    if (b.matches && b.matches('.btk-atc-btn, .bku-add, .bku-mx-add, [data-btk-add-to-basket]')) return true;
    var t = (b.textContent || b.value || '').replace(/\s+/g, ' ').trim();
    return /\badd\b.*\b(basket|cart|bag)\b/i.test(t) || /^\+?\s*add$/i.test(t);
  }
  // Fly the moment one is pressed.
  document.addEventListener('click', function (e) {
    var b = e.target && e.target.closest && e.target.closest('button, a, [role="button"], input[type="submit"]');
    if (!isAddButton(b)) return;
    lastX = e.clientX; lastY = e.clientY;
    if (Date.now() - lastFly < 1200) return;
    lastFly = Date.now();
    fly();
  }, true);

  function basketIcon() {
    var icon = document.getElementById('cart-icon');
    if (!icon) return null;
    var r = icon.getBoundingClientRect();
    return (r.width && r.height) ? icon : null;
  }

  function bounce(icon) {
    if (!icon || !icon.animate) return;
    icon.animate(
      [{ transform: 'scale(1)' }, { transform: 'scale(1.28)' }, { transform: 'scale(0.94)' }, { transform: 'scale(1)' }],
      { duration: 450, easing: 'ease-out' }
    );
  }

  function fly() {
    var icon = basketIcon();
    if (!icon) return;
    var img = (Date.now() - lastAt < 20000) ? lastImg : null;
    lastImg = null;
    var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var from = img && img.isConnected ? img.getBoundingClientRect() : null;
    if (from && (!from.width || !from.height) && lastX != null) from = { left: lastX, top: lastY, width: 120, height: 120 };
    if (reduced || !from || !from.width || !from.height || !document.body.animate) { bounce(icon); return; }

    var to = icon.getBoundingClientRect();
    var size = Math.max(60, Math.min(from.width, from.height, 120));
    // From the click (round two), else from the picture.
    var cx = (lastX != null) ? lastX : from.left + from.width / 2;
    var cy = (lastY != null) ? lastY : from.top + from.height / 2;
    var x0 = cx - size / 2;
    var y0 = cy - size / 2;
    var dx = (to.left + to.width / 2) - (x0 + size / 2);
    var dy = (to.top + to.height / 2) - (y0 + size / 2);

    var ghost = document.createElement('img');
    ghost.src = img.currentSrc || img.src;
    ghost.alt = '';
    ghost.setAttribute('aria-hidden', 'true');
    ghost.style.cssText = 'position:fixed;z-index:99999;pointer-events:none;object-fit:contain;'
      + 'background:#fff;border-radius:14px;box-shadow:0 10px 28px rgba(0,0,0,0.28);'
      + 'left:' + x0 + 'px;top:' + y0 + 'px;width:' + size + 'px;height:' + size + 'px;';
    document.body.appendChild(ghost);

    // An arc: up and across, then down into the icon, shrinking all the way.
    var anim = ghost.animate([
      { transform: 'translate(0, 0) scale(1)', opacity: 1 },
      { transform: 'translate(' + dx * 0.45 + 'px, ' + (dy * 0.45 - 90) + 'px) scale(0.55)', opacity: 1, offset: 0.55 },
      { transform: 'translate(' + dx + 'px, ' + dy + 'px) scale(0.08)', opacity: 0.35 }
    ], { duration: 700, easing: 'cubic-bezier(0.45, 0, 0.7, 0.6)' });
    lastX = lastY = null;
    var done = function () { if (ghost.parentNode) ghost.parentNode.removeChild(ghost); bounce(icon); };
    anim.onfinish = done;
    anim.oncancel = done;
  }

  function onAdd() {
    // One swoosh per add, however many of the events it fires.
    if (Date.now() - lastFly < 1200) return;
    lastFly = Date.now();
    fly();
  }

  ['btk:item-added', 'on:cart:add', 'on:line-item:change'].forEach(function (name) {
    document.addEventListener(name, onAdd);
  });

  window.BTKFlyToCart = { fly: fly };
})();
